import { endpoint } from './default';

// 取得所有公告
const getAllNoticeboard = () => endpoint.get('/noticeboard/all', {
  params: {
    tag: 'CodingWizard',
  },
});

// By日期取得所有公告
const getNoticeboardByDate = (from, to) => endpoint.get(`/noticeboard/between/${from}/${to}`, {
  params: {
    tag: 'CodingWizard',
  },
});

// 建立公告
const createNoticeboard = (data) => endpoint.post('/noticeboard', data, {
  params: {
    tag: 'CodingWizard',
  },
});

// 更新公告
const updateNoticeboard = (data, id) => endpoint.put(`/noticeboard/${id}`, data, {
  params: {
    tag: 'CodingWizard',
  },
});

// 刪除公告
const deleteNoticeboard = (id) => endpoint.delete(`/noticeboard/delete/${id}`, null, {
  params: {
    tag: 'CodingWizard',
  },
});

const getAllNoticeboardWatch = () => endpoint.get('/noticeboard_watch/all', {
  params: {
    tag: 'CodingWizard',
  },
});

const getNoticeboardWatchById = (id) => endpoint.get(`/noticeboard_watch/notice_board_id/${id}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getNoticeboardWatchByCwId = (id) => endpoint.get(`/noticeboard_watch/cw_id/${id}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getNoticeboardWatchByDate = (from, to) => endpoint.get(`/noticeboard_watch/between/${from}/${to}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const createNoticeboardWatch = (data) => endpoint.post('/noticeboard_watch', data, {
  params: {
    tag: 'CodingWizard',
  },
});

const updateNoticeboardWatch = (data, id) => endpoint.put(`/noticeboard_watch/${id}`, data, {
  params: {
    tag: 'CodingWizard',
  },
});

const deleteNoticeboardWatch = (id) => endpoint.delete(`/noticeboard_watch/delete/${id}`, null, {
  params: {
    tag: 'CodingWizard',
  },
});

export {
  getAllNoticeboard,
  getNoticeboardByDate,
  createNoticeboard,
  updateNoticeboard,
  deleteNoticeboard,
  getAllNoticeboardWatch,
  getNoticeboardWatchByDate,
  createNoticeboardWatch,
  updateNoticeboardWatch,
  deleteNoticeboardWatch,
  getNoticeboardWatchById,
  getNoticeboardWatchByCwId,
};
